import { render, staticRenderFns } from "./OrderViewDetails.vue?vue&type=template&id=2657c729&scoped=true"
import script from "./OrderViewDetails.vue?vue&type=script&lang=js"
export * from "./OrderViewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2657c729",
  null
  
)

export default component.exports